import { SettingsRoutes } from 'pages/settings/route/type'
import { InboxesRoutes } from 'pages/settings/pages/inboxes'
import { NewInboxRoutes } from './type'

const root = `${SettingsRoutes.root}/${InboxesRoutes.root}`
const newInbox = `${root}/${InboxesRoutes.new}`
const newInboxSteps = `${newInbox}/${NewInboxRoutes.steps}`
const newInboxStepsRoot = `${newInboxSteps}/${NewInboxRoutes.newInbox}`
const inboxNumbers = (id: number) => `${root}/${id}/${InboxesRoutes.numbers}`
const inboxNumbersAddNumber = (id: number) => `${inboxNumbers(id)}/${InboxesRoutes.addNumber}`
const inboxNumbersAssignNumber = (id: number) =>
  `${inboxNumbers(id)}/${InboxesRoutes.assignNumber}/${NewInboxRoutes.addSalesmsgNumbers}`
const inboxNumbersBuyNumber = (id: number) =>
  `${inboxNumbers(id)}/${InboxesRoutes.buyNumber}/${NewInboxRoutes.chooseNumber}`
const inboxNumbersAddNumberFromApp = (id: number) =>
  `${inboxNumbers(id)}/${InboxesRoutes.addNumberFromApp}/${NewInboxRoutes.selectAppAndNumbers}`
const inboxNumbersAddLandlineNumber = (id: number) =>
  `${inboxNumbers(id)}/${InboxesRoutes.textEnableLandline}/${NewInboxRoutes.enterNumber}`
const inboxCallingGeneral = (id: number) =>
  `${root}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.calling}/${InboxesRoutes.general}`

export const InboxesPath = {
  root: root,
  rootV1: `${SettingsRoutes.root}/${SettingsRoutes.organization}/${InboxesRoutes.root}/all-inboxes`,
  addInbox: {
    root: newInbox,
    steps: newInboxSteps,
    stepsRoot: newInboxStepsRoot,
  },
  inboxNumbers: inboxNumbers,
  inboxNumbersAddNumber: inboxNumbersAddNumber,
  inboxNumbersAssignNumber: inboxNumbersAssignNumber,
  inboxNumbersBuyNumber: inboxNumbersBuyNumber,
  inboxNumbersAddNumberFromApp: inboxNumbersAddNumberFromApp,
  inboxNumbersAddLandlineNumber: inboxNumbersAddLandlineNumber,
  inboxCallingGeneral: inboxCallingGeneral,
  inboxCallingV1: (id: number) => `/${InboxesPath.rootV1}/${id}/${InboxesRoutes.calling}`,
  inboxAiAutomation: (id: number) =>
    `/${root}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.messaging}/${InboxesRoutes.aiAutomation}`,
  inboxSmartCallFlow: (id: number) =>
    `/${root}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.calling}/${InboxesRoutes.smartCallFlow}`,
  businessHours: (id: number) =>
    `${root}/${id}/${InboxesRoutes.settings}/${InboxesRoutes.messaging}/${InboxesRoutes.businessHours}`,
}
